var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuickInfo = function SvgQuickInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "quick-info_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".quick-info_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    className: "quick-info_svg__st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17H13c-.6 0-1-.4-1-1V9.5c0-.3-.2-.5-.5-.5H10M11.7 6.5c-.1 0-.2.1-.2.2s.1.3.2.3.3-.1.3-.2-.1-.3-.3-.3",
    className: "quick-info_svg__st0"
  })));
};
export default SvgQuickInfo;